<div *ngIf="service.showSuccess" class="alert alert-success" role="alert">
  <div [innerHTML]="service.successMessage" *ngIf="service.successMessage"></div>
  <ng-container *ngTemplateOutlet="service.successTemplate"></ng-container>
</div>
<div *ngIf="service.showError" class="alert alert-danger" role="alert">
  <div [innerHTML]="service.errorMessage" *ngIf="service.errorMessage"></div>
  <ng-container *ngTemplateOutlet="service.errorTemplate"></ng-container>
</div>
